import { useQuery } from '@tanstack/react-query';
import * as versionApi from '../../api/version';

export const versionKeys = {
    all: ['version'] as const,
};

export const useVersion = () => {
    return useQuery({
        queryKey: versionKeys.all,
        queryFn: versionApi.getVersion,
        staleTime: Infinity,
        gcTime: Infinity,
    });
};
